import { render, staticRenderFns } from "./SignatureText.vue?vue&type=template&id=c92019b6&scoped=true"
import script from "./SignatureText.vue?vue&type=script&lang=js"
export * from "./SignatureText.vue?vue&type=script&lang=js"
import style0 from "./SignatureText.vue?vue&type=style&index=0&id=c92019b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c92019b6",
  null
  
)

export default component.exports